import React from "react";
import AccessoriesSectionCard from "../../components/common/Accessories-Section-Card/AccessoriesSectionCard";
import Carousel from "react-bootstrap/Carousel";
import { useSelector } from "react-redux";
import { FaPlus } from "react-icons/fa";
import { getSampleCurrencyFormat } from "../../utils/utils";
import { BsApple } from "react-icons/bs";

const AccessoriesList = () => {
  const { accessories } = useSelector((state) => state.home);

  return (
    <>
      <section className="custombreadcrumb">
        <div className="container">
          <ul className="breadcrumb justify-content-start">
            <li className="breadcrumb-item">
              <a href="/#/home">Home</a>
            </li>
            <li className="breadcrumb-item active">Accessories</li>
          </ul>
        </div>
      </section>
      <div className=" mobile-carousel-team-computer">
        <section className="productaddsection pb-5 pt-5">
          <div className="container">
            <div className="row">
              <div className="col-xl-9 mx-auto text-center pt-5">
                <div className="mainsection-title">
                  <h2>Accessories</h2>
                </div>
              </div>
            </div>
          </div>

          {accessories && accessories.length ? (
            <>
              {/* <!-- Desktop View Accessories section --> */}
              <div className="container-fluid d-none d-lg-block d-md-block">
                <div className="row">
                  {accessories &&
                    accessories.map((accessory, index) => (
                      <div className="col-md-3">
                        <AccessoriesSectionCard
                          id={accessory.sku}
                          PrductImg={accessory.image.url}
                          ProductDetail={accessory.name}
                          ProductPrice={getSampleCurrencyFormat(
                            accessory.price_range.minimum_price.final_price
                              .currency,
                            accessory.price_range.minimum_price.final_price
                              .value
                          )}
                        />
                      </div>
                    ))}
                </div>
              </div>
              {/* <!-- Desktop View Accessories section END --> */}

              {/* <!-- Mobile View Accessories section --> */}
              <div className="owl-carousel owl-theme circle-slider d-lg-none d-md-none m-3">
                <Carousel>
                  {accessories &&
                    accessories.map((accessory, index) => (
                      <Carousel.Item key={index}>
                        <div className="item">
                          <AccessoriesSectionCard
                            PrductImg={accessory.image.url}
                            ProductDetail={accessory.name}
                            ProductPrice={getSampleCurrencyFormat(
                              accessory.price_range.minimum_price.regular_price
                                .currency,
                              accessory.price_range.minimum_price.regular_price
                                .value
                            )}
                          />
                        </div>
                      </Carousel.Item>
                    ))}
                </Carousel>
              </div>
              {/* <!-- Mobile View Accessories section END --> */}
            </>
          ) : (
            <>
              <div className="commingsoon">
                <BsApple />
                Coming Soon...
              </div>
            </>
          )}
        </section>
      </div>
    </>
  );
};
export default AccessoriesList;
